"use strict";function r(t,i){if(t==null)return{};var o={};for(var e in t)if({}.hasOwnProperty.call(t,e)){if(i.indexOf(e)>=0)continue;o[e]=t[e]}return o}exports._objectWithoutPropertiesLoose=r;
